<template>
    <div id="pageTable">
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol == 'empleado'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-container v-else grid-list-xl fluid>
            <v-row wrap>
                <v-col xs="12" sm="12" md="12" xl="12" lg="12">
                    <data-table
                        ref="tablaEstadosCivil"
                        :tableName="'Estados civiles'"
                        :url="url"
                        :columns="columns"
                        :filters="filters"
                        @setFilters="setFilters"
                        :showAdvancedFilters="false"
                        :perPage="[10, 25, 50, 100]"
                    >
                        <template slot="actionButtonsLeft">
                            <div class="botonAgregar" style="padding-right: 12px;">
                                <v-btn
                                    rounded
                                    color="#004BAF"
                                    class="btnAdd"
                                    right
                                    @click="abrirModal('add')"
                                >
                                    <v-icon dark class="mr-2">add</v-icon>Agregar
                                    <div class="mr-4"></div>
                                </v-btn>
                            </div>
                        </template>

                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id" v-for="item in data">
                                <td>
                                    <div class="tblPrincipal">{{ item.nombre }}</div>
                                </td>

                                <td>
                                    <div>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    @click="abrirModal('update', item)"
                                                    small
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Editar</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    small
                                                    @click="eliminar(item.id, item.nombre)"
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>
        </v-container>

        <template>
            <v-row>
                <v-dialog v-model="dialog" persistent max-width="600px">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                    </template>

                    <v-card>
                        <v-card-title class="justify-center card_titulo">
                            <div class="headerModal">
                                <img :src="imgModal" class="imgModal" />
                                <h2 class="titleModal">{{ titulo_modal }}</h2>
                            </div>
                        </v-card-title>

                        <v-card-text class="card_texto">
                            <div id="loadingModal" v-show="!finaliza_carga">
                                <div id="loading">
                                    <v-progress-circular
                                        indeterminate
                                        :size="100"
                                        :width="7"
                                        color="blue"
                                    ></v-progress-circular>
                                </div>
                            </div>

                            <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                                <v-divider class="divider"></v-divider>
                                <v-row wrap>
                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <v-text-field
                                            outlined
                                            label="Nombre"
                                            v-model="estadoCivil.nombre"
                                            v-validate="'required'"
                                            data-vv-name="Nombre"
                                            :error-messages="errors.collect('Nombre')"
                                        >
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end card_accion">
                            <button
                                @click="cerrarModal()"
                                class="btnCerrar"
                                :disabled="loading_guardar"
                            >
                                Cancelar
                            </button>
                            <v-btn
                                class="btnGuardar"
                                @click="guardar()"
                                :loading="loading_guardar"
                            >
                                Guardar
                            </v-btn>       
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
    </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import apiEstadosCiviles from "../api/estadosCiviles";
import Datatable from "@/components/datatable/Datatable.vue";
import Notify from "@/plugins/notify";

export default {
    components: {
        "data-table": Datatable,
    },
    data() {
        return {
            url: "catalogo/estados-civiles/find",
            columns: [
                {
                    label: "Nombre",
                    name: "nombre",
                    filterable: false,
                },
                {
                    label: "Opciones",
                    name: "opciones",
                    filterable: false,
                },
            ],
            filters: {
                activo: true,
                paginate: true,
            },
            advancedSearch: {
                nombre: null,
            },
            loading_guardar: false,
            loading: true,
            dialog: false,
            search: "",
            datosLogin: "",
            complex: {
                selected: [],
                headers: [
                    {
                        text: "Nombre",
                        value: "nombre",
                    },
                    {
                        text: "Opciones",
                        value: "",
                    },
                ],
                items: [],
            },
            estadoCivil: {
                id: 0,
                nombre: "",
            },
            titulo_modal: "",
            finaliza_carga: false,
            action: "",
            imgModal: "/static/modal/estadoCivilCreate.svg",
            rol: null
        };
    },
    methods: {
        listar() {
            this.resetValues();
            this.loading = true;
            this.datosLogin = this.$session.get("usuario");
            let param = { activo: true, paginate: false };
            
        },
        setFilters() {
            let nombre = this.advancedSearch.nombre;

            let filterParams = {
                nombre: nombre,
            };
            let defaultParams = {
                activo: true,
                paginate: true,
            };
            if (filterParams != null) {
                Object.assign(defaultParams, filterParams);
            }
            this.filters = defaultParams;
            this.advancedSearch.nombre = null;
        },
        abrirModal(accion, item = null) {
            this.errors.clear();
            this.accion = accion;
            if (accion == "add") {
                this.titulo_modal = "Registro de estado civil";
                this.imgModal = "/static/modal/estadoCivilCreate.svg";
            } else {
                this.titulo_modal = "Actualizar de estado civil";
                this.imgModal = "/static/modal/estadoCivilUpdate.svg";
                this.estadoCivil.id = item.id;
                this.estadoCivil.nombre = item.nombre;
            }
            this.finaliza_carga = true;
            setTimeout(function() {
                document.getElementById("btnModal").click();
            }, 100);
        },
        guardar() {
            this.$validator.validate().then((result) => {
                if (result) {
                    this.loading_guardar = true;
                    if (this.accion === "add") {
                        apiEstadosCiviles.addEstadoCivil(this.estadoCivil).then((response) => {
                            this.$refs.tablaEstadosCivil.getData();
                            this.respuesta_ok("Se creó el nuevo estado civil satisfactoriamente.");
                            this.cerrarModal();
                        })
                        .catch((err) => {
                            this.respuesta_error(err);
                        });
                    } else if (this.accion === "update") {
                        apiEstadosCiviles.updateEstadoCivil(this.estadoCivil).then((response) => {
                            this.$refs.tablaEstadosCivil.getData();
                            this.respuesta_ok("Se actualizo el estado civil satisfactoriamente.");
                            this.cerrarModal();
                        })
                        .catch((err) => {
                            this.respuesta_error(err);
                        });
                    }
                }
            });
        },
        cerrarModal() {
            this.dialog = false;
            this.resetValues();
        },
        resetValues() {
            this.estadoCivil.id = 0;
            this.estadoCivil.nombre = "";
            this.loading_guardar = false;
        },
        eliminar(id, estadoCivil) {
            let self = this;
            Notify.Alert(
                "ADVERTENCIA",
                "¿Estás seguro que deseas eliminar el estado civil " +
                estadoCivil +
                "?",
                "Eliminar",
                () => {
                    apiEstadosCiviles.deleteEstadoCivil(id).then((response) => {
                        self.listar();
                        self.$refs.tablaEstadosCivil.getData();
                        this.respuesta_ok(
                            "El estado civil ha sido eliminado satisfactoriamente"
                        );
                    })
                    .catch((err) => {
                        console.log(err);
                        Notify.Error("Eliminar Estado Civil","Ocurrió un error al eliminar el estado civil.");
                    });
                }
            );
        },
        respuesta_error(err) {
            this.cerrarModal();
            this.loading_guardar = false;
            if(typeof err.response.data.error === 'string'){
                Notify.ErrorToast(err.response.data.error);
            }else{
                let error = Object.values(err.response.data.error);
                let leyenda = ``;

                for (var i = 0; i < error.length; i++) {
                    leyenda+= `* ` + error[i] + `\n`;
                }
                Notify.ErrorToast(leyenda);
            }
        },
        respuesta_ok(msj) {
            this.listar();
            this.cerrarModal();
            Notify.Success("Operación exitosa", msj);
        },
        redireccionar(){
            this.$router.push('/dashboard');
        },
    },
    created() {
        this.listar();
        this.rol = this.datosLogin.rol.name;
    },
};
</script>
